import React, {useState} from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger} from '../../components/Accordion/Accordion';
type AccordionProps = {
    id: string;
    title: string;
    description: any; /* arrays allow for complex HTML to be injected */
}

const list: AccordionProps[] = [
    {
        id: "1",
        title: "Title 1",
        description: [<p>This is some HTML content for accordion 1.</p>, <div>A div under the paragrpah tag</div>]
    },
    {
        id: "2",
        title: "Title 2",
        description:  [<p>This is some HTML content for accordion 2.</p>]
    },
    {
        id: "3",
        title: "Title 3",
        description:  [<p>This is some HTML content for accordion 3.</p>]
    },
];
const ComponentTestPage = (props:any) => {
    
    return (
        <>
        <h1>Component Test Page</h1>
        <h2>Accordion</h2>
        <Accordion>
            {
                list.map( (item, index) => (
                    <AccordionItem id={item.id} key={item.id}>
                        <AccordionTrigger color="secondary" headingLevel={3}>{ item.title }</AccordionTrigger>
                        <AccordionContent color="secondary">
                            {item.description}
                        </AccordionContent>
                    </AccordionItem>
                ))
            }
        </Accordion>
    </>
    );
  };
  
  export default ComponentTestPage;
